import React, { useState } from "react";
import { IoClose } from "react-icons/io5";

const AssignedTo = ({
  onClose,
  adminEmails,
  // onEmailSelect,
  // handleInputChange,
  onFieldChange,
}) => {
  const [selectedEmail, setSelectedEmail] = useState("");

  // const handleChange = (e) => {
  //   setSelectedEmail(e.target.value);
  //   onEmailSelect(e.target.value);
  // };
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    onFieldChange(field.column_name || field.name, value); // Notify parent of changes
  };
  const handleSelectChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case "assignTo":
        onFieldChange("assignTo", value); // Notify parent of changes
        break;
      case "priority":
        onFieldChange("priority", value); // Notify parent of changes
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-[rgba(0,0,0,0.5)] fixed z-50 top-0 left-0 w-full h-full flex justify-center items-center">
      <div className="bg-white w-[550px] relative min-h-[70vh] p-4 rounded-lg">
        <h1 className=" p-2 border-gray-400 border-b-2">Assigned To</h1>
        <IoClose
          className="absolute text-[25px] top-6 right-6 cursor-pointer"
          onClick={onClose}
        />
        <div className="flex flex-col gap-5 p-4">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              name=""
              id=""
              className="w-4 h-4 cursor-pointer"
            />
            <label htmlFor="">Assign to Me</label>
          </div>
          <div className="flex gap-3 flex-col">
            <label htmlFor="assignTo">
              Assign To <span className=" text-red-600">*</span>
            </label>
            <select
              name="assignTo"
              id="assignTo"
              className="w-full border border-gray-400 rounded-md p-2"
              value={selectedEmail}
              // onChange={handleChange}
              onChange={(e) => handleSelectChange(e, "city")}
              required
            >
              <option value="">Select an admin</option>
              {adminEmails.map((item, index) => (
                <option key={index} value={item.a_email}>
                  {item.a_email}
                </option>
              ))}
            </select>
          </div>
          <div className="flex gap-3">
            <div className=" flex gap-3 flex-col w-[50%]">
              <label htmlFor="dueDate">Due Date</label>
              <input
                type="date"
                id="dueDate"
                name="dueDate"
                onChange={(e) => onFieldChange(e, { column_name: "dueDate" })}
                className="border border-gray-400 cursor-not-allowed rounded-md p-2"
                required
              />
            </div>
            <div className=" flex gap-3 flex-col w-[50%]">
              <label htmlFor="priority">Priority</label>
              <select
                name="priority"
                id="priority"
                className="border border-gray-400 rounded-md p-2"
                onChange={(e) => handleSelectChange(e, "priority")}
                required
              >
                <option value="Low" className="text-orange-500">
                  Low
                </option>
                <option value="Medium" className="text-green-600">
                  Medium
                </option>
                <option value="High" className="text-red-700">
                  High
                </option>
              </select>
            </div>
          </div>
          <div className="flex gap-3 flex-col">
            <label htmlFor="comment">Comment</label>
            <textarea
              name="comment"
              id="comment"
              rows="5"
              placeholder="write..."
              className="border bg-gray-200 border-gray-400 rounded-md p-2"
              onChange={(e) => onFieldChange(e, { column_name: "comment" })}
              required
            ></textarea>
          </div>
          <div className="flex gap-3 justify-end">
            <button
              type="submit"
              onClick={onClose}
              className="bg-blue-600 hover:bg-blue-400 transition-all duration-300 ease-in-out text-white font-bold p-2 rounded-lg"
            >
              Assign
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignedTo;
